/**
 * Hours Tabs
 * ----------
 */

if($('.hours-tabs').length) {

    let hoursTabsNavItems = $('.hours-group-selection li'),
        hoursTabMuseum = $('#hours-items-museum'),
        hoursTabCafe = $('#hours-items-cafe'),
        hoursTabsContainer = $('.hours-right');

    if($(window).width() <= 991) {

    }

    hoursTabsContainer.css('min-height', hoursTabMuseum.outerHeight());

    $(window).on('resize', function () {
        hoursTabsContainer.css('min-height', '');
        setTimeout(function () { hoursTabsContainer.css('min-height', hoursTabMuseum.outerHeight()); });
    });

    hoursTabsNavItems.on('click', function () {

        let tabSelected = $(this).data('group');

        hoursTabsNavItems.not($(this)).removeClass('active');
        $(this).addClass('active');

        if(tabSelected === "museum") {

            hoursTabCafe.addClass('hiding');

            setTimeout(function () { hoursTabCafe.addClass('d-none'); }, 310);
            setTimeout(function () { hoursTabMuseum.removeClass('d-none'); }, 320);
            setTimeout(function () { hoursTabMuseum.removeClass('hiding'); }, 330);

        } else {

            hoursTabMuseum.addClass('hiding');

            setTimeout(function () { hoursTabMuseum.addClass('d-none'); }, 310);
            setTimeout(function () { hoursTabCafe.removeClass('d-none'); }, 320);
            setTimeout(function () { hoursTabCafe.removeClass('hiding'); }, 330);

        }

    });

}